export const TERMS_OF_USE_URL = "https://worldofwow.com/terms-conditions#terms-of-use";
export const PRIVACY_POLICY_URL = "https://worldofwow.com/terms-conditions#privacy-policy";
